import { render, staticRenderFns } from "./themeUploadAvatar.vue?vue&type=template&id=233264d4&"
import script from "./themeUploadAvatar.vue?vue&type=script&lang=js&"
export * from "./themeUploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./themeUploadAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports